import React__default from 'react';

const PromotionLabel = ({ children  })=>/*#__PURE__*/ React__default.createElement("span", {
        className: "product-block-promotion-label"
    }, children)
;
var PromotionLabel$1 = PromotionLabel;

export { PromotionLabel, PromotionLabel$1 as default };
//# sourceMappingURL=PromotionLabel.js.map
